import { ORDER } from '@arpeggi/shared'
import { useState } from 'react'
import { useAsyncEffect } from '../../../__legacy__/components/platform/explore/common/utils'
import { OrderBy } from '../../../__legacy__/components/platform/new-explore/hooks/useSounds'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import ArpRegistry from '../../arp-registry/ArpRegistry'
import { useVerifyMedia } from '../../verified-media'

export const useArpVerifiedRemixes = (media: IArpMedia) => {
  const { verifiedIDs } = useVerifyMedia({ arpMediaId: media.id })
  const [data, setData] = useState<IArpMedia[]>([])
  const [order, setOrder] = useState<ORDER>('desc')
  const [orderBy, setOrderBy] = useState<OrderBy>('createdAt')

  const status = useAsyncEffect(async () => {
    const remixes = await ArpRegistry.getByIdsAsync(verifiedIDs)
    setData(remixes)
  }, [media, verifiedIDs])

  const ordered = data.sort((a, b) => {
    const valueA = a[orderBy]
    const valueB = b[orderBy]
    if (typeof valueA === 'string') {
      return valueA.localeCompare(valueB)
    }
    return valueA - valueB
  })
  const reversed = order === 'desc' ? ordered : ordered.reverse()

  const handleOrderChange = (newOrderBy: OrderBy) => {
    if (newOrderBy === orderBy) return setOrder(order === 'asc' ? 'desc' : 'asc')
    setOrderBy(newOrderBy)
    setOrder('desc')
  }
  return { data: reversed, status, handleOrderChange, order, orderBy }
}
